<template>
  <div>
    <!-- <div class="choose-box--feature">
      <div class="choose-box--feature__small">FEATURES FOR</div>
      <div class="choose-box--feature__large">Patients</div>
      <div class="choose-box--feature__medium">
        Connect with a community that provides support for individuals living
        with chronic conditions. Find comfort in knowing that you are not alone
        and explore various resources to help you manage your health journey.
      </div>
    </div> -->
    <div class="create-support reverse">
      <div class="create-support__image">
        <div class="primary-image">
          <img alt="img" src="../../../../assets/images/product1.png" class="img-src" :style="{ width: '336px', height: '270px' }" />
        </div>
        <div class="secondary-image">
          <img alt="img" src="../../../../assets/images/image-frame.png" class="img-src" :style="{ width: '274px', height: '270px' }" />
        </div>
      </div>
      <div class="create-support__description" :style="{ 'max-width': '690px' }">
        <div class="create-support__description__small">FEATURES FOR</div>
        <div class="create-support__description__large">Patients</div>
        <div class="create-support__description__medium">
          Connect with a community that provides support for individuals living with chronic conditions. Find comfort in knowing that you are not alone and explore various resources to help you manage
          your health journey.
        </div>
      </div>
    </div>
    <div class="create-support">
      <div class="create-support__image">
        <div class="primary-image">
          <img alt="img" src="../../../../assets/images/product2.png" class="img-src" :style="{ width: '335px', height: '270px' }" />
        </div>
        <div class="secondary-image">
          <img alt="img" src="../../../../assets/images/image-frame.png" class="img-src" :style="{ width: '274px', height: '270px' }" />
        </div>
      </div>
      <div class="create-support__description" :style="{ 'max-width': '690px' }">
        <div class="create-support__description__small">FEATURES FOR</div>
        <div class="create-support__description__large">Caregivers</div>
        <div class="create-support__description__medium">
          Do you know a loved one or someone close to you that has been diagnosed with a chronic condition? MyCircles provides a platform to support those living with chronic conditions.<br />
          If you are a family member, friend or caregiver who wishes to learn more about living with a chronic condition, join MyCircles to support the wellness of your community.
        </div>
      </div>
    </div>
    <!-- <div class="create-support reverse" :style="{ display: 'none' }">
      <div class="create-support__image">
        <div class="primary-image">
          <img alt="img" src="../../../../assets/images/product3.png" class="img-src" />
        </div>
        <div class="secondary-image">
          <img alt="img" src="../../../../assets/images/image-frame.png" class="img-src" />
        </div>
      </div>
      <div class="create-support__description" :style="{ 'max-width': '690px' }">
        <div class="create-support__description__small">Product Line one</div>
        <div class="create-support__description__large">Product Line Two</div>
        <div class="create-support__description__medium">
          Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit.
          Mauris turpis nisl, molestieNam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi.
          Nullam vehicula nisi velit. Mauris turpis nisl, molestie
        </div>
      </div>
    </div> -->
    <div class="caregiver full" :style="{ display: 'none' }">
      <!-- <div class="choose-box--feature dovemed-wrapper">
        <div class="choose-box--feature__small">FEATURES FOR</div>
        <div class="choose-box--feature__large ">Caregivers</div>
        <div class="choose-box--feature__medium">
          Do you know a loved one or someone close to you that has been
          diagnosed with a chronic condition? MyCircles provides a platform to
          support those living with chronic conditions.<br />
          If you are a family member, friend or caregiver who wishes to learn
          more about living with a chronic condition, join MyCircles to support
          the wellness of your community.
        </div>
      </div> -->
      <!-- I have added the wrapper -->

      <!-- <div class="create-support dovemed-wrapper">
        <div class="create-support__image">
          <div class="primary-image">
            <img alt="img" src="../../../../assets/images/product4.png" class="img-src" />
          </div>
          <div class="secondary-image">
            <img alt="img" src="../../../../assets/images/image-frame.png" class="img-src" />
          </div>
        </div>
        <div class="create-support__description" :style="{ 'max-width': '690px' }">
          <div class="create-support__description__small">Product Line one</div>
          <div class="create-support__description__large">Product Line Two</div>
          <div class="create-support__description__medium">
            Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit.
            Mauris turpis nisl, molestieNam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi.
            Nullam vehicula nisi velit. Mauris turpis nisl, molestie
          </div>
        </div>
      </div> -->
      
      <!-- <div class="create-support   dovemed-wrapper">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/care2.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">Product Line one</div>
          <div class="create-support__description__large">Product Line Two</div>
          <div class="create-support__description__medium">
            Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit. Mauris turpis nisl, molestieNam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit. Mauris turpis nisl, molestie
          </div>
        </div>
      </div>
      <div class="create-support reverse  dovemed-wrapper">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/product-one.png"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">Product Line one</div>
          <div class="create-support__description__large">Product Line Two</div>
          <div class="create-support__description__medium">
            Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit. Mauris turpis nisl, molestieNam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit. Mauris turpis nisl, molestie
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "PatientStatic",
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/App/circle/AllCircleStaticPages/patientStatic.vue